import * as React from 'react';
import { ThemeProvider as JssThemeProvider } from 'react-jss';
import connectTheme from './connectTheme';

const ThemeProvider = (props) => {

    return (
      <JssThemeProvider theme={{}} >
        {props.children}
      </JssThemeProvider>
    );
};

export default connectTheme(ThemeProvider);
